module.exports = __webpack_public_path__ + "static/postcard_back_en-bb1cfc0afe105aa7f12d8bac9c37b40a.jpg";